import { useState } from 'react';
import './App.css';
import axios from 'axios';
import { AnimatePresence, motion } from 'framer-motion';
import Spline from '@splinetool/react-spline';
import Swal from 'sweetalert2';

function App() {
  let API_KEY = "64b0f1cca8a649f196f222423231812";
  let [loading, setLoading] = useState(false);
  let [city, setCity] = useState("");
  let [welcome, setWelcome] = useState(true)
  let [type, setType] = useState("current")
  let [day, setDay] = useState("")
  let [time, setTime] = useState("")
  let [dateTime, setDateTime] = useState("")
  let [name, setName] = useState("")
  let [region, setRegion] = useState("")
  let [country, setCountry] = useState("")
  let [latitude, setLatitude] = useState("")
  let [longitude, setLongitude] = useState("")
  let [localTime, setLocalTime] = useState("")
  let [condition, setCondition] = useState("")
  let [humidity, setHumidity] = useState("")
  let [temperature, setTemperature] = useState("")
  let [windSpeed, setWindSpeed] = useState("")
  let [windDirection, setWindDirection] = useState("")

  const spans = Array.from({ length: 10 }, (_, index) => (
    <span key={index} className="load" style={{ '--i': `${index + 1}px` }}></span>
  ));

  let [icon, setIcon] = useState("")
  let bg
  if (icon === "//cdn.weatherapi.com/weather/64x64/night/113.png") {
    bg = "night"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/day/113.png") {
    bg = "day"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/day/116.png") {
    bg = "brightday"
  } else if ((icon === "//cdn.weatherapi.com/weather/64x64/day/308.png") || (icon === "//cdn.weatherapi.com/weather/64x64/night/302.png") || (icon === "//cdn.weatherapi.com/weather/64x64/day/356.png")) {
    bg = "rain"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/night/122.png") {
    bg = "cloud"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/day/122.png") {
    bg = "daycloud"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/night/116.png") {
    bg = "cloudnight"
  } else if ((icon === "//cdn.weatherapi.com/weather/64x64/day/296.png") || (icon === "//cdn.weatherapi.com/weather/64x64/night/296.png")) {
    bg = "lightrain"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/night/389.png") {
    bg = "deepthunder"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/night/143.png") {
    bg = "nightmist"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/day/143.png") {
    bg = "mist"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/day/302.png") {
    bg = "light-rain"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/day/386.png") {
    bg = "lightthunder"
  } else if (icon === "//cdn.weatherapi.com/weather/64x64/night/248.png") {
    bg = "foggy"
  }

  const getData = async () => {
    if (type === "current") {
      if (city.length < 1) {
        Swal.fire(
          'Enter a City!',
          '',
          'info'
        )
      } else {
        setLoading(true)
        try {
          await axios.get(`https://api.weatherapi.com/v1/${type}.json?key=${API_KEY}&q=${city}&aqi=nos`).then(response => {
            console.log(response)
            setName(response.data.location.name)
            setRegion(response.data.location.region)
            setCountry(response.data.location.country)
            setLatitude(response.data.location.lat)
            setLongitude(response.data.location.lon)
            setLocalTime(response.data.location.localtime)
            setCondition(response.data.current.condition.text)
            setIcon(response.data.current.condition.icon)
            setHumidity(response.data.current.humidity)
            setTemperature(response.data.current.temperature)
            setWindSpeed(response.data.current.wind_mph)
            setWindDirection(response.data.current.wind_dir)
            setTemperature(response.data.current.temp_c)
            setLoading(false)
          })
        } catch (err) {
          if (err.response.data.error.code === 1006) {
            Swal.fire(
              `${city.toUpperCase()} don't fucking exist!`,
              "Enter a Valid City!",
              'info'
            )
          }
          setLoading(false)
        }
      }
    } else {
      if (city.length < 1) {
        Swal.fire(
          'Enter a City!',
          'Enter a Valid City ',
          'info'
        )
      } else if (day.length < 1) {
        Swal.fire(
          'What day in the future you wanna see bro!',
          '',
          'info'
        )
      } else if (time.length < 1) {
        Swal.fire(
          'Around what time bro!',
          '',
          'info'
        )
      } else {
        setLoading(true)
        try {
          await axios.get(`https://api.weatherapi.com/v1/${type}.json?key=${API_KEY}&q=${city}${type === "forecast" ? "&days=10" : ""}&aqi=nos`).then
            (response => {
              if (day.toLowerCase() === "today") {
                // console.log(response.data.forecast.forecastday)
                // console.log(response.data.forecast.forecastday[0])
                // console.log(response.data.forecast.forecastday[0].hour)
                if (time === "00:00") {
                  console.log(response.data.forecast.forecastday[0].hour[0])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[0].time)
                  setCondition(response.data.forecast.forecastday[0].hour[0].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[0].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[0].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[0].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[0].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[0].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[0].temp_c)
                } else if (time === "01:00") {
                  console.log(response.data.forecast.forecastday[0].hour[1])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[1].time)
                  setCondition(response.data.forecast.forecastday[0].hour[1].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[1].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[1].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[1].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[1].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[1].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[1].temp_c)
                } else if (time === "02:00") {
                  console.log(response.data.forecast.forecastday[0].hour[2])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[2].time)
                  setCondition(response.data.forecast.forecastday[0].hour[2].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[2].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[2].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[2].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[2].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[2].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[2].temp_c)
                } else if (time === "03:00") {
                  console.log(response.data.forecast.forecastday[0].hour[3])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[3].time)
                  setCondition(response.data.forecast.forecastday[0].hour[3].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[3].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[3].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[3].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[3].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[3].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[3].temp_c)
                } else if (time === "04:00") {
                  console.log(response.data.forecast.forecastday[0].hour[4])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[4].time)
                  setCondition(response.data.forecast.forecastday[0].hour[4].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[4].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[4].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[4].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[4].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[4].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[4].temp_c)
                } else if (time === "05:00") {
                  console.log(response.data.forecast.forecastday[0].hour[5])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[5].time)
                  setCondition(response.data.forecast.forecastday[0].hour[5].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[5].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[5].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[5].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[5].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[5].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[5].temp_c)
                } else if (time === "06:00") {
                  console.log(response.data.forecast.forecastday[0].hour[6])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[6].time)
                  setCondition(response.data.forecast.forecastday[0].hour[6].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[6].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[6].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[6].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[6].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[6].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[6].temp_c)
                } else if (time === "07:00") {
                  console.log(response.data.forecast.forecastday[0].hour[7])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[7].time)
                  setCondition(response.data.forecast.forecastday[0].hour[7].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[7].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[7].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[7].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[7].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[7].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[7].temp_c)
                } else if (time === "08:00") {
                  console.log(response.data.forecast.forecastday[0].hour[8])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[8].time)
                  setCondition(response.data.forecast.forecastday[0].hour[8].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[8].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[8].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[8].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[8].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[8].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[8].temp_c)
                } else if (time === "09:00") {
                  console.log(response.data.forecast.forecastday[0].hour[9])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[9].time)
                  setCondition(response.data.forecast.forecastday[0].hour[9].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[9].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[9].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[9].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[9].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[9].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[9].temp_c)
                } else if (time === "10:00") {
                  console.log(response.data.forecast.forecastday[0].hour[10])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[10].time)
                  setCondition(response.data.forecast.forecastday[0].hour[10].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[10].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[10].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[10].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[10].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[10].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[10].temp_c)
                } else if (time === "11:00") {
                  console.log(response.data.forecast.forecastday[0].hour[11])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[11].time)
                  setCondition(response.data.forecast.forecastday[0].hour[11].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[11].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[11].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[11].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[11].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[11].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[11].temp_c)
                } else if (time === "12:00") {
                  console.log(response.data.forecast.forecastday[0].hour[12])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[12].time)
                  setCondition(response.data.forecast.forecastday[0].hour[12].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[12].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[12].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[12].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[12].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[12].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[12].temp_c)
                } else if (time === "13:00") {
                  console.log(response.data.forecast.forecastday[0].hour[13])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[13].time)
                  setCondition(response.data.forecast.forecastday[0].hour[13].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[13].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[13].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[13].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[13].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[13].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[13].temp_c)
                } else if (time === "14:00") {
                  console.log(response.data.forecast.forecastday[0].hour[14])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[14].time)
                  setCondition(response.data.forecast.forecastday[0].hour[14].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[14].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[14].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[14].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[14].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[14].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[14].temp_c)
                } else if (time === "15:00") {
                  console.log(response.data.forecast.forecastday[0].hour[15])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[15].time)
                  setCondition(response.data.forecast.forecastday[0].hour[15].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[15].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[15].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[15].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[15].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[15].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[15].temp_c)
                } else if (time === "16:00") {
                  console.log(response.data.forecast.forecastday[0].hour[16])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[16].time)
                  setCondition(response.data.forecast.forecastday[0].hour[16].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[16].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[16].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[16].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[16].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[16].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[16].temp_c)
                } else if (time === "17:00") {
                  console.log(response.data.forecast.forecastday[0].hour[17])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[17].time)
                  setCondition(response.data.forecast.forecastday[0].hour[17].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[17].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[17].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[17].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[17].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[17].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[17].temp_c)
                } else if (time === "18:00") {
                  console.log(response.data.forecast.forecastday[0].hour[18])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[18].time)
                  setCondition(response.data.forecast.forecastday[0].hour[18].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[18].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[18].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[18].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[18].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[18].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[18].temp_c)
                } else if (time === "19:00") {
                  console.log(response.data.forecast.forecastday[0].hour[19])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[19].time)
                  setCondition(response.data.forecast.forecastday[0].hour[19].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[19].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[19].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[19].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[19].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[19].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[19].temp_c)
                } else if (time === "20:00") {
                  console.log(response.data.forecast.forecastday[0].hour[20])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[20].time)
                  setCondition(response.data.forecast.forecastday[0].hour[20].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[20].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[20].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[20].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[20].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[20].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[20].temp_c)
                } else if (time === "21:00") {
                  console.log(response.data.forecast.forecastday[0].hour[21])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[21].time)
                  setCondition(response.data.forecast.forecastday[0].hour[21].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[21].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[21].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[21].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[21].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[21].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[21].temp_c)
                } else if (time === "22:00") {
                  console.log(response.data.forecast.forecastday[0].hour[22])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[22].time)
                  setCondition(response.data.forecast.forecastday[0].hour[22].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[22].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[22].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[22].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[22].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[22].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[22].temp_c)
                } else if (time === "23:00") {
                  console.log(response.data.forecast.forecastday[0].hour[23])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[0].hour[23].time)
                  setCondition(response.data.forecast.forecastday[0].hour[23].condition.text)
                  setIcon(response.data.forecast.forecastday[0].hour[23].condition.icon)
                  setHumidity(response.data.forecast.forecastday[0].hour[23].humidity)
                  setTemperature(response.data.forecast.forecastday[0].hour[23].temperature)
                  setWindSpeed(response.data.forecast.forecastday[0].hour[23].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[0].hour[23].wind_dir)
                  setTemperature(response.data.forecast.forecastday[0].hour[23].temp_c)
                }
              } else if (day.toLowerCase() === "tomorrow") {
                console.log(response.data.forecast.forecastday[1])
                if (time === "00:00") {
                  console.log(response.data.forecast.forecastday[1].hour[0])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[0].time)
                  setCondition(response.data.forecast.forecastday[1].hour[0].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[0].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[0].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[0].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[0].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[0].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[0].temp_c)
                } else if (time === "01:00") {
                  console.log(response.data.forecast.forecastday[1].hour[1])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[1].time)
                  setCondition(response.data.forecast.forecastday[1].hour[1].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[1].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[1].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[1].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[1].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[1].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[1].temp_c)
                } else if (time === "02:00") {
                  console.log(response.data.forecast.forecastday[1].hour[2])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[2].time)
                  setCondition(response.data.forecast.forecastday[1].hour[2].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[2].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[2].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[2].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[2].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[2].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[2].temp_c)
                } else if (time === "03:00") {
                  console.log(response.data.forecast.forecastday[1].hour[3])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[3].time)
                  setCondition(response.data.forecast.forecastday[1].hour[3].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[3].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[3].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[3].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[3].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[3].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[3].temp_c)
                } else if (time === "04:00") {
                  console.log(response.data.forecast.forecastday[1].hour[4])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[4].time)
                  setCondition(response.data.forecast.forecastday[1].hour[4].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[4].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[4].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[4].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[4].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[4].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[4].temp_c)
                } else if (time === "05:00") {
                  console.log(response.data.forecast.forecastday[1].hour[5])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[5].time)
                  setCondition(response.data.forecast.forecastday[1].hour[5].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[5].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[5].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[5].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[5].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[5].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[5].temp_c)
                } else if (time === "06:00") {
                  console.log(response.data.forecast.forecastday[1].hour[6])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[6].time)
                  setCondition(response.data.forecast.forecastday[1].hour[6].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[6].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[6].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[6].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[6].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[6].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[6].temp_c)
                } else if (time === "07:00") {
                  console.log(response.data.forecast.forecastday[1].hour[7])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[7].time)
                  setCondition(response.data.forecast.forecastday[1].hour[7].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[7].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[7].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[7].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[7].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[7].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[7].temp_c)
                } else if (time === "08:00") {
                  console.log(response.data.forecast.forecastday[1].hour[8])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[8].time)
                  setCondition(response.data.forecast.forecastday[1].hour[8].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[8].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[8].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[8].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[8].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[8].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[8].temp_c)
                } else if (time === "09:00") {
                  console.log(response.data.forecast.forecastday[1].hour[9])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[9].time)
                  setCondition(response.data.forecast.forecastday[1].hour[9].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[9].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[9].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[9].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[9].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[9].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[9].temp_c)
                } else if (time === "10:00") {
                  console.log(response.data.forecast.forecastday[1].hour[10])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[10].time)
                  setCondition(response.data.forecast.forecastday[1].hour[10].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[10].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[10].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[10].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[10].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[10].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[10].temp_c)
                } else if (time === "11:00") {
                  console.log(response.data.forecast.forecastday[1].hour[11])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[11].time)
                  setCondition(response.data.forecast.forecastday[1].hour[11].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[11].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[11].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[11].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[11].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[11].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[11].temp_c)
                } else if (time === "12:00") {
                  console.log(response.data.forecast.forecastday[1].hour[12])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[12].time)
                  setCondition(response.data.forecast.forecastday[1].hour[12].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[12].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[12].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[12].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[12].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[12].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[12].temp_c)
                } else if (time === "13:00") {
                  console.log(response.data.forecast.forecastday[1].hour[13])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[13].time)
                  setCondition(response.data.forecast.forecastday[1].hour[13].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[13].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[13].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[13].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[13].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[13].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[13].temp_c)
                } else if (time === "14:00") {
                  console.log(response.data.forecast.forecastday[1].hour[14])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[14].time)
                  setCondition(response.data.forecast.forecastday[1].hour[14].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[14].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[14].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[14].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[14].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[14].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[14].temp_c)
                } else if (time === "15:00") {
                  console.log(response.data.forecast.forecastday[1].hour[15])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[15].time)
                  setCondition(response.data.forecast.forecastday[1].hour[15].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[15].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[15].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[15].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[15].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[15].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[15].temp_c)
                } else if (time === "16:00") {
                  console.log(response.data.forecast.forecastday[1].hour[16])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[16].time)
                  setCondition(response.data.forecast.forecastday[1].hour[16].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[16].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[16].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[16].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[16].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[16].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[16].temp_c)
                } else if (time === "17:00") {
                  console.log(response.data.forecast.forecastday[1].hour[17])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[17].time)
                  setCondition(response.data.forecast.forecastday[1].hour[17].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[17].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[17].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[17].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[17].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[17].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[17].temp_c)
                } else if (time === "18:00") {
                  console.log(response.data.forecast.forecastday[1].hour[18])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[18].time)
                  setCondition(response.data.forecast.forecastday[1].hour[18].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[18].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[18].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[18].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[18].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[18].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[18].temp_c)
                } else if (time === "19:00") {
                  console.log(response.data.forecast.forecastday[1].hour[19])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[19].time)
                  setCondition(response.data.forecast.forecastday[1].hour[19].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[19].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[19].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[19].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[19].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[19].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[19].temp_c)
                } else if (time === "20:00") {
                  console.log(response.data.forecast.forecastday[1].hour[20])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[20].time)
                  setCondition(response.data.forecast.forecastday[1].hour[20].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[20].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[20].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[20].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[20].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[20].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[20].temp_c)
                } else if (time === "21:00") {
                  console.log(response.data.forecast.forecastday[1].hour[21])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[21].time)
                  setCondition(response.data.forecast.forecastday[1].hour[21].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[21].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[21].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[21].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[21].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[21].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[21].temp_c)
                } else if (time === "22:00") {
                  console.log(response.data.forecast.forecastday[1].hour[22])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[22].time)
                  setCondition(response.data.forecast.forecastday[1].hour[22].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[22].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[22].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[22].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[22].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[22].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[22].temp_c)
                } else if (time === "23:00") {
                  console.log(response.data.forecast.forecastday[1].hour[23])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[1].hour[23].time)
                  setCondition(response.data.forecast.forecastday[1].hour[23].condition.text)
                  setIcon(response.data.forecast.forecastday[1].hour[23].condition.icon)
                  setHumidity(response.data.forecast.forecastday[1].hour[23].humidity)
                  setTemperature(response.data.forecast.forecastday[1].hour[23].temperature)
                  setWindSpeed(response.data.forecast.forecastday[1].hour[23].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[1].hour[23].wind_dir)
                  setTemperature(response.data.forecast.forecastday[1].hour[23].temp_c)
                }
              } else {
                console.log(response.data.forecast.forecastday[2])
                if (time === "00:00") {
                  console.log(response.data.forecast.forecastday[2].hour[0])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[0].time)
                  setCondition(response.data.forecast.forecastday[2].hour[0].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[0].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[0].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[0].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[0].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[0].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[0].temp_c)
                } else if (time === "01:00") {
                  console.log(response.data.forecast.forecastday[2].hour[1])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[1].time)
                  setCondition(response.data.forecast.forecastday[2].hour[1].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[1].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[1].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[1].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[1].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[1].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[1].temp_c)
                } else if (time === "02:00") {
                  console.log(response.data.forecast.forecastday[2].hour[2])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[2].time)
                  setCondition(response.data.forecast.forecastday[2].hour[2].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[2].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[2].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[2].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[2].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[2].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[2].temp_c)
                } else if (time === "03:00") {
                  console.log(response.data.forecast.forecastday[2].hour[3])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[3].time)
                  setCondition(response.data.forecast.forecastday[2].hour[3].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[3].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[3].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[3].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[3].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[3].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[3].temp_c)
                } else if (time === "04:00") {
                  console.log(response.data.forecast.forecastday[2].hour[4])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[4].time)
                  setCondition(response.data.forecast.forecastday[2].hour[4].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[4].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[4].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[4].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[4].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[4].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[4].temp_c)
                } else if (time === "05:00") {
                  console.log(response.data.forecast.forecastday[2].hour[5])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[5].time)
                  setCondition(response.data.forecast.forecastday[2].hour[5].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[5].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[5].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[5].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[5].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[5].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[5].temp_c)
                } else if (time === "06:00") {
                  console.log(response.data.forecast.forecastday[2].hour[6])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[6].time)
                  setCondition(response.data.forecast.forecastday[2].hour[6].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[6].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[6].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[6].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[6].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[6].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[6].temp_c)
                } else if (time === "07:00") {
                  console.log(response.data.forecast.forecastday[2].hour[7])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[7].time)
                  setCondition(response.data.forecast.forecastday[2].hour[7].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[7].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[7].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[7].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[7].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[7].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[7].temp_c)
                } else if (time === "08:00") {
                  console.log(response.data.forecast.forecastday[2].hour[8])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[8].time)
                  setCondition(response.data.forecast.forecastday[2].hour[8].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[8].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[8].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[8].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[8].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[8].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[8].temp_c)
                } else if (time === "09:00") {
                  console.log(response.data.forecast.forecastday[2].hour[9])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[9].time)
                  setCondition(response.data.forecast.forecastday[2].hour[9].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[9].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[9].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[9].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[9].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[9].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[9].temp_c)
                } else if (time === "10:00") {
                  console.log(response.data.forecast.forecastday[2].hour[10])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[10].time)
                  setCondition(response.data.forecast.forecastday[2].hour[10].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[10].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[10].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[10].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[10].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[10].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[10].temp_c)
                } else if (time === "11:00") {
                  console.log(response.data.forecast.forecastday[2].hour[11])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[11].time)
                  setCondition(response.data.forecast.forecastday[2].hour[11].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[11].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[11].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[11].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[11].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[11].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[11].temp_c)
                } else if (time === "12:00") {
                  console.log(response.data.forecast.forecastday[2].hour[12])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[12].time)
                  setCondition(response.data.forecast.forecastday[2].hour[12].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[12].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[12].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[12].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[12].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[12].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[12].temp_c)
                } else if (time === "13:00") {
                  console.log(response.data.forecast.forecastday[2].hour[13])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[13].time)
                  setCondition(response.data.forecast.forecastday[2].hour[13].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[13].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[13].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[13].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[13].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[13].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[13].temp_c)
                } else if (time === "14:00") {
                  console.log(response.data.forecast.forecastday[2].hour[14])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[14].time)
                  setCondition(response.data.forecast.forecastday[2].hour[14].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[14].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[14].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[14].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[14].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[14].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[14].temp_c)
                } else if (time === "15:00") {
                  console.log(response.data.forecast.forecastday[2].hour[15])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[15].time)
                  setCondition(response.data.forecast.forecastday[2].hour[15].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[15].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[15].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[15].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[15].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[15].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[15].temp_c)
                } else if (time === "16:00") {
                  console.log(response.data.forecast.forecastday[2].hour[16])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[16].time)
                  setCondition(response.data.forecast.forecastday[2].hour[16].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[16].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[16].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[16].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[16].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[16].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[16].temp_c)
                } else if (time === "17:00") {
                  console.log(response.data.forecast.forecastday[2].hour[17])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[17].time)
                  setCondition(response.data.forecast.forecastday[2].hour[17].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[17].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[17].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[17].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[17].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[17].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[17].temp_c)
                } else if (time === "18:00") {
                  console.log(response.data.forecast.forecastday[2].hour[18])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[18].time)
                  setCondition(response.data.forecast.forecastday[2].hour[18].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[18].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[18].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[18].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[18].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[18].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[18].temp_c)
                } else if (time === "19:00") {
                  console.log(response.data.forecast.forecastday[2].hour[19])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[19].time)
                  setCondition(response.data.forecast.forecastday[2].hour[19].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[19].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[19].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[19].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[19].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[19].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[19].temp_c)
                } else if (time === "20:00") {
                  console.log(response.data.forecast.forecastday[2].hour[20])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[20].time)
                  setCondition(response.data.forecast.forecastday[2].hour[20].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[20].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[20].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[20].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[20].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[20].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[20].temp_c)
                } else if (time === "21:00") {
                  console.log(response.data.forecast.forecastday[2].hour[21])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[21].time)
                  setCondition(response.data.forecast.forecastday[2].hour[21].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[21].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[21].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[21].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[21].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[21].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[21].temp_c)
                } else if (time === "22:00") {
                  console.log(response.data.forecast.forecastday[2].hour[22])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[22].time)
                  setCondition(response.data.forecast.forecastday[2].hour[22].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[22].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[22].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[22].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[22].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[22].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[22].temp_c)
                } else if (time === "23:00") {
                  console.log(response.data.forecast.forecastday[2].hour[23])
                  setName(response.data.location.name)
                  setRegion(response.data.location.region)
                  setCountry(response.data.location.country)
                  setLatitude(response.data.location.lat)
                  setLongitude(response.data.location.lon)
                  setDateTime(response.data.forecast.forecastday[2].hour[23].time)
                  setCondition(response.data.forecast.forecastday[2].hour[23].condition.text)
                  setIcon(response.data.forecast.forecastday[2].hour[23].condition.icon)
                  setHumidity(response.data.forecast.forecastday[2].hour[23].humidity)
                  setTemperature(response.data.forecast.forecastday[2].hour[23].temperature)
                  setWindSpeed(response.data.forecast.forecastday[2].hour[23].wind_mph)
                  setWindDirection(response.data.forecast.forecastday[2].hour[23].wind_dir)
                  setTemperature(response.data.forecast.forecastday[2].hour[23].temp_c)
                }
              }
              setLoading(false)
            })
        } catch (err) {
          if (err.response.data.error.code === 1006) {
            Swal.fire(
              `${city.toUpperCase()} don't fucking exist!`,
              "Enter a Valid City!",
              'info'
            )
          }
          setLoading(false)
        }
      }
    }
  }

  return (
    <div className="App">
      <div className={welcome ? "intro" : "intro animate"}>
        <div className="earth">
          <Spline scene="https://prod.spline.design/5SMnSg-yQDWKAL0T/scene.splinecode" />
        </div>
        <div className="text">
          <motion.h1 initial={{ x: "-100vw" }} animate={{ x: 0, transition: { delay: 1, duration: .5 } }}>Let's Explore Weather Forecast of Cities of your choice!!</motion.h1>
          <motion.h3 initial={{ x: "100vw" }} animate={{ x: 0, transition: { delay: 1.75 } }}>Shall we?</motion.h3>
          <motion.button onClick={() => setWelcome(false)} initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 2.6, duration: 1.5 } }}>LET'S GOOO!!!</motion.button>
        </div>
        <motion.div className="bg" initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 1 } }}>
          <div><div className="img1"></div></div>
          <div><div className="img2"></div></div>
          <div><div className="img3"></div></div>
          <div><div className="img4"></div></div>
          <div><div className="img5"></div></div>
        </motion.div>
      </div>

      <motion.div className="content" initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 1 } }}>
        {/* {loading &&
        // <AnimatePresence mode='wait'>
          <motion.div className="loader" initial={{x: "-100vw"}} animate={{x: 0}} exit={{x: "100vw", transition: {duration: 5}}}>
            {spans}
            {console.log(spans)}
          </motion.div>
        // </AnimatePresence>
        } */}
        <div className={loading ? "loader show" : "loader"}>
          {spans}
        </div>
        <div className={`bgimg ${bg}`}>
          <img src={icon} alt="" />
        </div>
        <div className="content">
          <div className="info">
            {type === "current" ?
              <input type="text" placeholder='Enter City of your choice' value={city} onChange={(e) => setCity(e.target.value)} /> :
              <div className='forecastInput'>
                <input type="text" placeholder='Enter City of your choice' value={city} onChange={(e) => setCity(e.target.value)} />
                <div>
                  <select name="day" id="" className="day" value={day} onChange={(e) => setDay(e.target.value)}>
                    {!day ? <option value="">{day ? day : "What day?"}</option> : ""}
                    <option value="Today">Today</option>
                    <option value="Tomorrow">Tomorrow</option>
                    <option value="Day after tomorrow">Day after tomorrow</option>
                  </select>
                  <select name="time" id="" className="day" value={time} onChange={(e) => setTime(e.target.value)}>
                    {!time ? <option value="">{time ? time : "Around what time?"}</option> : ""}
                    <option value="00:00">00:00</option>
                    <option value="01:00">01:00</option>
                    <option value="02:00">02:00</option>
                    <option value="03:00">03:00</option>
                    <option value="04:00">04:00</option>
                    <option value="05:00">05:00</option>
                    <option value="06:00">06:00</option>
                    <option value="07:00">07:00</option>
                    <option value="08:00">08:00</option>
                    <option value="09:00">09:00</option>
                    <option value="10:00">10:00</option>
                    <option value="11:00">11:00</option>
                    <option value="12:00">12:00</option>
                    <option value="13:00">13:00</option>
                    <option value="14:00">14:00</option>
                    <option value="15:00">15:00</option>
                    <option value="16:00">16:00</option>
                    <option value="17:00">17:00</option>
                    <option value="18:00">18:00</option>
                    <option value="19:00">19:00</option>
                    <option value="20:00">20:00</option>
                    <option value="21:00">21:00</option>
                    <option value="22:00">22:00</option>
                    <option value="23:00">23:00</option>
                  </select>
                </div>
              </div>}
            <div className={type === "current" ? "select" : "select forecast"}>
              <div className="option"></div>
              <div className="current" onClick={() => setType("current")}>
                <h3>Current</h3>
                <p>Provides Info on the Current Weather</p>
              </div>
              <div className="forecast" onClick={() => setType("forecast")}>
                <h3>Forecast</h3>
                <p>Provides 2 days Future Weather Info</p>
              </div>
            </div>
            <button onClick={() => getData()}>Retrieve Weather Data!</button>
          </div>

          <div className="moreInfo">
            {type === "current" ? <div className="content">
              <div>
                <h4>Name: <span>{name}</span></h4>
              </div>
              <div>
                <h4>Region: <span>{region}</span></h4>
              </div>
              <div>
                <h4>Country: <span>{country}</span></h4>
              </div>
              <div>
                <h4>Latitude: <span>{latitude}</span></h4>
              </div>
              <div>
                <h4>Longitude: <span>{longitude}</span></h4>
              </div>
              <div>
                <h4>Local Time: <span>{localTime}</span></h4>
              </div>
              <div>
                <h4>Weather Condition: <span>{condition}</span></h4>
              </div>
              <div>
                <h4>Humidity: <span>{humidity}</span></h4>
              </div>
              <div>
                <h4>Temperature(C): <span>{temperature}</span></h4>
              </div>
              <div>
                <h4>Wind Speed(MPH): <span>{windSpeed}</span></h4>
              </div>
              <div>
                <h4>Wind Direction: <span>{windDirection}</span></h4>
              </div>
            </div> : <div className={type === "forecast" ? "contentfore content " : "content"}>
              <div>
                <h4>Name: <span>{name}</span></h4>
              </div>
              <div>
                <h4>Region: <span>{region}</span></h4>
              </div>
              <div>
                <h4>Country: <span>{country}</span></h4>
              </div>
              <div>
                <h4>Date & Time: <span>{dateTime}</span></h4>
              </div>
              <div>
                <h4>Latitude: <span>{latitude}</span></h4>
              </div>
              <div>
                <h4>Longitude: <span>{longitude}</span></h4>
              </div>
              <div>
                <h4>Weather Condition: <span>{condition}</span></h4>
              </div>
              <div>
                <h4>Humidity: <span>{humidity}</span></h4>
              </div>
              <div>
                <h4>Temperature(C): <span>{temperature}</span></h4>
              </div>
              <div>
                <h4>Wind Speed(MPH): <span>{windSpeed}</span></h4>
              </div>
              <div>
                <h4>Wind Direction: <span>{windDirection}</span></h4>
              </div>
            </div>}
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default App;
